import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { FacebookIcon, RedditIcon, TumblrIcon, EmailIcon, TwitterIcon } from 'react-share';
export const ShareIcon = (_param)=>{
    var { type } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    switch(type){
        case 'facebook':
            return /*#__PURE__*/ React.createElement(FacebookIcon, props);
        case 'twitter':
            return /*#__PURE__*/ React.createElement(TwitterIcon, props);
        case 'reddit':
            return /*#__PURE__*/ React.createElement(RedditIcon, props);
        case 'tumblr':
            return /*#__PURE__*/ React.createElement(TumblrIcon, props);
        case 'email':
            return /*#__PURE__*/ React.createElement(EmailIcon, props);
        default:
            return null;
    }
};
ShareIcon.displayName = 'ShareIcon';
export default ShareIcon;
